import easyfyAxios from '@shared/easyfy.axios';

namespace Meds.Web.Services.Favourite {

  export interface UpdateFavouriteRequest {
    productId: string;
    add: boolean;
  }

  export const UpdateFavourite = async (
    data: UpdateFavouriteRequest,
  ): Promise<any> => {
    const url = `/api/favourites?handler=update`;
    return easyfyAxios.post(
      url,
      data,
      null
    );
  };

  export const GetFavourites = async (): Promise<any> => {
    const url = `/api/favourites?handler=get`;
    return easyfyAxios.get(
      url
    );
  };
}

export default Meds.Web.Services.Favourite;